import styled from "styled-components";

export const Image = styled.img<{ hasImage: boolean }>`
  width: ${({ hasImage }) => (hasImage ? "169px" : "188px")};
  height: ${({ hasImage }) => (hasImage ? "118px" : "103px")};
  margin-bottom: 8px;
`;
